// Vendor Libraries
import { createAction, props } from '@ngrx/store';
export const setTechChartSecuritylistName = createAction('[Tech Chart] Set Security List Name', props());
